module.exports = __webpack_public_path__ + "img/lipinwenchuang.afb1f4bd.png";